import { useMemo } from "react";

/**
 * useHost - 获取当前host信息，并提供host(path)方法，返回完整url
 * 支持浏览器和SSR
 */
export function useHost() {
  // 获取host
  const hostStr = useMemo(() => {
    if (typeof window !== 'undefined') {
      // 浏览器环境
      return window.location.origin;
    } else if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_VERCEL_URL) {
      // Vercel等云环境
      return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
    } else if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_HOST) {
      // 其它自定义host
      return process.env.NEXT_PUBLIC_HOST;
    }
    return '';
  }, []);

  // 拼接完整url
  function host(path: string) {
    if (!path.startsWith('/')) path = '/' + path;
    return hostStr + path;
  }

  return { host };
} 